export class Evaluacion {
    model = {
        id: { value: null, header: 'Código' },
        nivel1: {
            value: 0,
            header: null,
            required: 'Requerido',
            maxLength: 'Máximo 100',
            minLength: 'Mínimo 0.1',
            max: 100,
            min: 0.1
        },
        nivel2: {
            value: 0,
            header: null,
            required: 'Requerido',
            maxLength: 'Máximo 100',
            minLength: 'Mínimo 0.1',
            max: 100,
            min: 0.1
        },
        nivel3: {
            value: 0,
            header: null,
            required: 'Requerido',
            maxLength: 'Máximo 100',
            minLength: 'Mínimo 0.1',
            max: 100,
            min: 0.1
        },
        nivel4: {
            value: 0,
            header: null,
            required: 'Requerido',
            maxLength: 'Máximo 100',
            minLength: 'Mínimo 0.1',
            max: 100,
            min: 0.1
        },
        nivel5: {
            value: 0,
            header: null,
            required: 'Requerido',
            maxLength: 'Máximo 100',
            minLength: 'Mínimo 0.1',
            max: 100,
            min: 0.1
        },
    }
}
